module.exports = __webpack_public_path__ + "img/mp4.8ad5c5e1.png";